<template>
  <a-modal 
    class="myModal myDialog screenShotDialog smallDialog" 
    :visible="visible" 
    :title="systemStyle == 'style1' ? undefined : title" 
    v-drag-modal
    :destroyOnClose="true" 
    :width="800" 
    @cancel="handleCancel">
    <div v-if="systemStyle == 'style1'" class="tixing">
      <span>{{title}}</span>
    </div>
    <vue-cropper
      ref="cropper"
      :img="options.img"
      :info="true"
      :autoCrop="options.autoCrop"
      :autoCropWidth="options.autoCropWidth"
      :autoCropHeight="options.autoCropHeight"
      :fixedBox="options.fixedBox"
      @realTime="realTime"
    >
    </vue-cropper>
    <template slot="footer">
      <a-button class="defaultBtn" @click="handleCancel">取消</a-button>
      <a-button class="primaryBtn" :loading="confirmLoading" @click="okHandel">裁剪</a-button>
    </template>
  </a-modal>
</template>

<script>
import html2canvas from "html2canvas"
import { VueCropper } from 'vue-cropper'
  export default {
    components: {
      VueCropper
    },
    data() {
      return {
        systemStyle: localStorage.getItem('style'),
        visible: false,
        confirmLoading: false,
        title:'剪切图片',
        options: {
          img: '',             //裁剪图片的地址
          canScale: true,      //图片是否允许滚轮缩放
          autoCrop: true,      //是否默认生成截图框
          autoCropWidth: 350,  //默认生成截图框宽度
          autoCropHeight: 200, //默认生成截图框高度
          fixed: true,         //是否开启截图框宽高固定比例
          fixedNumber: [1.53, 1], //截图框的宽高比例
          full: false,         //false按原比例裁切图片，不失真
          fixedBox: false,      //固定截图框大小，不允许改变
          canMove: false,      //上传图片是否可以移动
          canMoveBox: true,    //截图框能否拖动
          original: false,     //上传图片按照原始比例渲染
          centerBox: true,     //截图框是否被限制在图片里面
          height: true,        //是否按照设备的dpr 输出等比例图片
          infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
          maxImgSize: 3000,    //限制图片最大宽度和高度
          enlarge: 1,          //图片根据截图框输出比例倍数
          mode: '350px 200px'  //图片默认渲染方式
        },
        previews: {},
        parentInfo:null,
      }
    },
    methods: {
      open(parentInfo){
        // 父组件传来的信息，截图完把信息带回去
        this.parentInfo = parentInfo
        let dom = document.querySelector('.cesium-widget')
        new html2canvas(dom, {
          allowTaint: false,
          useCORS: true,
          height: dom.scrollHeight,
          width: dom.scrollWidth
        }).then(canvas => {
          this.visible = true
          this.$nextTick(() => {
            let cropperWidth = document.querySelector('.vue-cropper').offsetWidth
            let canvasWidth = canvas.style.width
            canvasWidth = Number(canvasWidth.slice(0,-2))
            let canvasHeight = canvas.style.height
            canvasHeight = Number(canvasHeight.slice(0,-2))
            document.querySelector('.vue-cropper').style.height = cropperWidth * canvasHeight / canvasWidth  + 'px'
            this.options.img = canvas.toDataURL("image/jpg", 1)
          })
        })
      },
      realTime(data) {
        this.previews = data
      },
      okHandel() {
        this.confirmLoading = true
        this.$refs.cropper.getCropBlob(async(data) => {
          this.confirmLoading = false
          this.handleCancel()
          this.$emit('handleShot',data,this.parentInfo)
        })
      },
      handleCancel(){
        this.visible = false
        this.$emit('handleShot')
      },
    },
  }
</script>

<style lang="less" scoped>
.myModal {
  .imgBox {
    width: 100%;
    height: 100%;
    #screenImg {
      width: 100%;
      height: 100%;
    }
  }
}
.tixing {
  top:-1.1%;
  width:174px;
}
/deep/ .ant-modal-body {
  height: 385px;
}
</style>